import { Api } from '@/store/api';
import { GetSignedUrlResponse, PostVideoToAltruResponse } from '@/store/videos/types';
import { globalRegions } from 'altru-types';
import getMimeTypeFromFileExtension from '@/utils/getMimeTypeFromFileExtension';
import getExtensionFromFileName from '@/utils/getExtensionFromFileName';
import { Credentials } from '@/store/auth/types';

export async function getSignedUrlWithPayload(
  videoName: string,
  videoType: string,
  region: globalRegions,
  payload: string,
): Promise<GetSignedUrlResponse> {
  try {
    let verifiedVideoType = videoType;

    if (!verifiedVideoType) {
      const fileExtension = getExtensionFromFileName(videoName);
      verifiedVideoType = getMimeTypeFromFileExtension(fileExtension);
    }

    const response = await Api.get(
      `/api/${region}/files/signed_url?file_type=${verifiedVideoType}&file_name=${videoName}&payload=${payload}`,
    );
    return response.data;
  } catch (e) {
    return e.response;
  }
}

export async function getSignedUrlWithCredentials(
  videoName: string,
  videoType: string,
  region: globalRegions,
  headers: Credentials,
): Promise<GetSignedUrlResponse> {
  try {
    let verifiedVideoType = videoType;

    if (!verifiedVideoType) {
      const fileExtension = getExtensionFromFileName(videoName);
      verifiedVideoType = getMimeTypeFromFileExtension(fileExtension);
    }

    const response = await Api.get(
      `/api/${region}/files/signed_url?file_type=${verifiedVideoType}&file_name=${videoName}`,
      {
        headers,
      },
    );
    return response.data;
  } catch (e) {
    return e.response;
  }
}

export async function putVideoToSignedUrl(signedUrl: string, video: File): Promise<void> {
  const fileExtension = getExtensionFromFileName(video.name);
  const videoType = video.type && video.type !== '' ? video.type : getMimeTypeFromFileExtension(fileExtension);

  return await Api.put(signedUrl, video, {
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': videoType,
    },
  });
}

export async function postAnonymousVideoToAltru({
  payload,
  region,
}: {
  payload: string;
  region: globalRegions;
}): PostVideoToAltruResponse {
  const response = await Api.post(`/api/${region}/answers/anonymous_create`, JSON.parse(payload), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function postVideoToAltru({
  payload,
  region,
  answerId,
  headers,
}: {
  payload: string;
  region: globalRegions;
  answerId: number;
  headers: Credentials;
}): PostVideoToAltruResponse {
  const response = await Api.put(`/api/${region}/answers/${answerId}`, JSON.parse(payload), {
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
  return response.data;
}
